import { useContext } from 'react';

import { PortalConfigContext } from 'src/context';
import { useLegacyReferralProgram } from 'src/features/referrals/useLegacyReferralProgram';
import { useAppSelector } from 'src/hooks/useStore';
import { RootState } from 'src/store';
import { UrlUtils } from 'src/utils';

export const useReferralLink = () => {
  const isLegacyReferralProgram = useLegacyReferralProgram();
  const portalConfig = useContext(PortalConfigContext);
  const { firstName, ref } = useAppSelector((state: RootState) => ({
    ref: state.user.ref,
    firstName: state.user.instance?.attributes.given_name,
  }));
  // Under growth-loops the workspace earns the referral, so the link names
  // the workspace rather than whichever teammate copied it. Legacy plans stay
  // on the old program, so their links keep naming the user.
  const referralCode = isLegacyReferralProgram
    ? ref
    : portalConfig.portalHeader;

  /**
   * Based on domain, creates a referral link.
   * Some social sharing sites do not support query params unless they are encoded.
   * Hence this function also returns encoded referral link
   * @returns  - { referralLink, encodedReferralLink }
   */
  const getReferralLink = () => {
    let referralLink = '';
    let encodedReferralLink = '';

    const marketingSiteUrl = UrlUtils.getMarketingSiteUrl();
    referralLink = `${marketingSiteUrl}/referrals/${firstName}_${referralCode}`;
    encodedReferralLink = `${marketingSiteUrl}/referrals/${firstName}_${referralCode}`;
    return { referralLink, encodedReferralLink };
  };

  const links = getReferralLink();
  return links;
};
